import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { PrimaryButton, Icon } from '@common/components';
import {
  SEND_APP_INVITATION_MUTATION,
  SYNC_WORKER_UKG_DATA_MUTATION,
} from '@scheduling/graphql/mutations/worker';

interface WorkerActiveDropdownProps {
  worker: {
    id: string;
  };
  setShowDrawer: (value: boolean) => void;
  canEditWorkers?: boolean;
  integrationEnabled?: boolean;
}

export function WorkerActiveDropdown({
  worker,
  setShowDrawer,
  canEditWorkers,
  integrationEnabled,
}: WorkerActiveDropdownProps) {
  const items: MenuProps['items'] = [
    canEditWorkers
      ? {
          key: 'edit',

          icon: <Icon icon="pencil" kind="regular" size="sm" />,
          label: 'Edit',
        }
      : null,
    {
      key: 'invite',

      icon: <Icon icon="paperPlane" kind="light" size="sm" />,
      label: 'Send Invite',
    },
    integrationEnabled
      ? {
          key: 'sync',

          icon: <Icon icon="sync" kind="regular" size="sm" />,
          label: 'Sync',
        }
      : null,
  ];

  const [sendInvite] = useMutation(SEND_APP_INVITATION_MUTATION, {
    onCompleted(data) {
      const { message } = data?.sendAppInvitation || {};
      createMessage('success', message);
    },
  });

  const onClick: MenuProps['onClick'] = ({ key }: { key: string }) => {
    if (key === 'edit') {
      setShowDrawer(true);
    } else if (key === 'sync') {
      onActionSyncWorker(worker.id);
    } else if (key === 'invite') {
      sendInvite({
        variables: {
          workerId: worker.id,
        },
      });
    }
  };

  const [performSyncWorker] = useMutation(SYNC_WORKER_UKG_DATA_MUTATION, {
    onCompleted: (data) => {
      if (data?.syncWorkerUkgData?.error) {
        createMessage('error', data.syncWorkerUkgData.error);
      } else {
        createMessage(
          'success',
          'Profile sync initiated. Profile information will be complete in less than a minute. Please refresh this page to continue'
        );
      }
    },
    onError: () => {
      createMessage('error', 'Worker sync failed. Please try again.');
    },
  });

  const onActionSyncWorker = (workerId: string) => {
    performSyncWorker({
      variables: {
        workerId,
      },
    });
  };

  return (
    <>
      <Dropdown menu={{ items, onClick }}>
        <PrimaryButton>
          Actions
          <Icon icon="chevronDown" size="sm" kind="regular" />
        </PrimaryButton>
      </Dropdown>
    </>
  );
}
